"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M19.474 4.342a.5.5 0 1 0-.948.316l.094.283c-1.832-.867-3.452-.913-4.782-.534-1.58.45-2.698 1.481-3.254 2.316a.5.5 0 1 0 .832.554c.444-.665 1.376-1.533 2.696-1.909 1.094-.31 2.494-.295 4.16.515l-.43.143a.5.5 0 1 0 .316.948l1.5-.5a.5.5 0 0 0 .316-.632zM21 9.995a.5.5 0 0 0-1 .01c.01.984-.292 2.043-1.36 3.148a.5.5 0 0 0 .72.695c1.253-1.297 1.654-2.61 1.64-3.853m-9.309 3.043A.5.5 0 0 1 12 13.5v4a.5.5 0 1 1-1 0v-2.793l-.146.147a.5.5 0 0 1-.708-.707l1-1a.5.5 0 0 1 .545-.109"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M9 7.5a.5.5 0 1 0-1 0V8H6.5A1.5 1.5 0 0 0 5 9.5v9A1.5 1.5 0 0 0 6.5 20h10a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 16.5 8H15v-.5a.5.5 0 0 0-1 0V8H9zm8 3.5H6V9.5a.5.5 0 0 1 .5-.5H8v.5a.5.5 0 0 0 1 0V9h5v.5a.5.5 0 0 0 1 0V9h1.5a.5.5 0 0 1 .5.5zM6 12h11v6.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5z"
  })]
}), 'Subscription');
//# sourceMappingURL=index.js.map